/**
 * 料金表(全体)
 *
 * No.    日付          更新者    更新内容
 *   1    2021/10/25   大友      新規作成
 *
 * @summary ユーティリティーフォーム関連
 * @copyright 2021, WINGSYSTEMS K.K.
 */
'use strict';

import '../../_initial';
import '../../_common';
import {Device} from '../../common/util';

// 画面の向きによって閾値を変える
const observeThreshold = (document.documentElement.clientWidth < Device.SIZE_TB)
                       ? 0.3 : 0.7;

// ページ内リンクスムーススクロール
const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');
  for (let i = 0; i < smoothScrollTrigger.length; i++){
    smoothScrollTrigger[i].addEventListener('click', (e) => {
      e.preventDefault();
      let href = smoothScrollTrigger[i].getAttribute('href');
      let targetElement = document.getElementById(href.replace('#', ''));
      const rect = targetElement.getBoundingClientRect().top;
      const offset = window.pageYOffset;
      // 上に移動する場合はナビバー分考慮する
      const gap = 60;
      const target = rect + offset - gap;
      const actual_target = (document.documentElement.scrollTop > target) ? target - 40 : target;
      //console.log(target, actual_target);
      window.scrollTo({
        top: actual_target,
        behavior: 'smooth',
      });
    });
  }

// 料金グループボタン追跡
const stickyTop = document.querySelector('.sticky-top');

/**
 * 目次の色を変える関数
 * @param element
 */
const activateIndex = function(element) {
    // すでにアクティブになっている目次を選択
    const currentActiveIndex = document.querySelector("#charge-groups .active");
    // すでにアクティブになっているものが0個の時（=null）以外は、activeクラスを除去
    if (currentActiveIndex !== null) {
        currentActiveIndex.classList.remove("active");
    }
    // 引数で渡されたDOMが飛び先のaタグを選択し、activeクラスを付与
    const targetId = element.dataset.chargegruopId;
    //const newActiveIndex = document.querySelector(`a[href='#${element.id}']`);
    const newActiveIndex = document.querySelector(`a[href='#${targetId}']`);
    newActiveIndex.classList.add("active");
};

// 今回の交差を監視する要素(料金形態、一律料金コース)
const boxes = document.querySelectorAll('.charge-group-row');
// IntersectionObserver オブジェクトを作成
// 交差時に実行するコールバック関数を渡す
const observer = new IntersectionObserver((entries) => {
    // 交差検知をしたもののなかで、isIntersectingがtrueのDOMを色を変える関数に渡す
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            activateIndex(entry.target);
        }
    });
}, {
    // root: document.querySelector('main'),
    // rootMargin: `${topMargin}px 0px 0px 0px`,
    threshold: observeThreshold // 閾値
});
// それぞれのboxを監視する
boxes.forEach(box => {
    observer.observe(box);
});

// 下スクロールでメニューが消えて上スクロールでメニューが出てくる
var startPos = 0, winScrollTop = 0;
// scrollイベントを設定
window.addEventListener('scroll', function() {
    winScrollTop = this.scrollY;

    if (winScrollTop >= startPos) {
        // 下にスクロールされた時
        if (winScrollTop >= 40) {
            // 下に200pxスクロールされたら隠す
            document.querySelector('nav.navbar').classList.add('hide');
            //stickyTop.classList.remove('with-navbar');
            stickyTop.style.top = '0px';
        }
    } else {
        // 上にスクロールされた時
        // 自動スクロール時はナビバー表示しない
        document.querySelector('nav.navbar').classList.remove('hide');
        //stickyTop.classList.add('with-navbar');
        const navbarHeight = document.querySelector('nav.navbar').clientHeight;
        stickyTop.style.top = `${navbarHeight+1}px`;
    }
    startPos = winScrollTop;
});

// ロード時、scrollイベント発火
const triggerEvent = new Event('scroll');
window.dispatchEvent(triggerEvent);
